import { ChainType } from 'types';

import gitbookIcon from 'assets/images/git-book.png';
import discordIcon from 'assets/images/logos/discord-logo.png';
import mediumIcon from 'assets/images/logos/medium-logo.png';
import twitterIcon from 'assets/images/logos/twitter-logo.png';

import testnetIcon from 'assets/images/testnet-icon.png';
import faqsIcon from 'assets/images/faq-icon.png';

interface CommunityOptions {
  name: string,
  icon: string,
  link: string,
}
interface NeedHelpOptions extends CommunityOptions {
  ecosystem: ChainType[],
}

export const communityOptions: CommunityOptions[] = [
  {
    name: 'Gitbook',
    icon: gitbookIcon,
    link: 'https://cables-finance-1.gitbook.io/cables.finance/',
  },
  {
    name: 'Discord',
    icon: discordIcon,
    link: 'https://discord.com/invite/UCAhKKz9qD',
  },
  {
    name: 'Twitter',
    icon: twitterIcon,
    link: 'https://twitter.com/CablesFinance',
  },
  {
    name: 'Medium',
    icon: mediumIcon,
    link: 'https://cables-finance.medium.com/',
  },
];

export const needHelpOptions: NeedHelpOptions[] = [
  {
    name: 'Mainnet Guide',
    icon: testnetIcon,
    link: 'https://cables-finance-1.gitbook.io/cables.finance/avalanche-get-started/mainnet-guide',
    ecosystem: [ChainType.Mainnet],
  },
  {
    name: 'FAQs',
    icon: faqsIcon,
    link: 'https://cables-finance-1.gitbook.io/cables.finance/support/faq',
    ecosystem: [ChainType.Mainnet, ChainType.Testnet],
  },
];
